export enum enumScheduleTimePeriod {
  Daily = 1,
  Weekly,
  Monthly
  // 'Monthly Special',
  // 'Run After',
  // 'On Demand'
}


export namespace enumScheduleTimePeriod {
  export function values() {
    return Object.keys(enumScheduleTimePeriod).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

